import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconEyeOnFill = ({ width = 24, height = 24, ...props }: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.25 12L21.9303 12.3156C22.0232 12.1155 22.023 11.884 21.9301 11.6838L21.9289 11.6812L21.9262 11.6755L21.9171 11.6563L21.9077 11.6367L21.884 11.588C21.8554 11.5297 21.8136 11.4463 21.7589 11.3414C21.6494 11.1318 21.4879 10.8356 21.2758 10.4817C20.8525 9.77538 20.223 8.83081 19.3982 7.88276C17.767 6.00751 15.2654 4 12 4C8.73456 4 6.23304 6.00751 4.60175 7.88276C3.77704 8.83081 3.14747 9.77538 2.72422 10.4817C2.51211 10.8356 2.35057 11.1318 2.24115 11.3414C2.1864 11.4463 2.14462 11.5297 2.11599 11.588C2.10167 11.6172 2.09064 11.6401 2.08291 11.6563L2.0738 11.6755L2.0711 11.6812L2.07022 11.6831C2.07022 11.6831 2.06966 11.6844 2.75 12L2.06966 11.6844C1.97678 11.8845 1.97678 12.1155 2.06966 12.3156L2.0711 12.3188L2.0738 12.3245L2.08291 12.3437C2.09064 12.3599 2.10167 12.3828 2.11599 12.412C2.14462 12.4703 2.1864 12.5537 2.24115 12.6586C2.35057 12.8682 2.51211 13.1644 2.72422 13.5183C3.14747 14.2246 3.77704 15.1692 4.60175 16.1172C6.23304 17.9925 8.73456 20 12 20C15.2654 20 17.767 17.9925 19.3982 16.1172C20.223 15.1692 20.8525 14.2246 21.2758 13.5183C21.4879 13.1644 21.6494 12.8682 21.7589 12.6586C21.8136 12.5537 21.8554 12.4703 21.884 12.412C21.8983 12.3828 21.9094 12.3599 21.9171 12.3437L21.9262 12.3245L21.9289 12.3188L21.9298 12.3169C21.9298 12.3169 21.9303 12.3156 21.25 12ZM2.06966 12.3156C2.06966 12.3156 2.07078 12.315 2.15722 12.2749C2.24266 12.2353 2.41142 12.1571 2.74468 12.0025L2.06966 12.3156ZM21.25 12C21.9303 11.6844 21.9301 11.6838 21.9301 11.6838L21.25 12ZM12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default memo(IconEyeOnFill)
